<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo},
    data() {
        return {
            company: {
                contact_email: '',
                nip: '',
                company_name: '',
                city: '',
                address: '',
            },
            termsAccepted: false,
            privacyAccepted: false,
            loading: false,
            errors: {}
        }
    },
    methods: {
        submit() {
            this.loading = true;
            axios.post('/registration-requests', this.company).then(() => {
                this.$toast.success(this.$t('auth.sign_up.registration_request_sent'));
                this.$router.push({name: 'home'});
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">
                        <form @submit.prevent="submit" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.sign_up.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <b-field :label="$t('auth.fields.email.name')"
                                         :type="errors.contact_email ? 'is-danger' : null"
                                         :message="errors.contact_email ? errors.contact_email[0] : null">
                                    <b-input required
                                             type="email"
                                             v-model="company.contact_email"
                                             icon="at"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('companies.fields.nip.name')"
                                         :type="errors.nip ? 'is-danger' : null"
                                         :message="errors.nip ? errors.nip[0] : null">
                                    <b-input required
                                             v-model="company.nip"
                                             icon="account-card-outline"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('companies.fields.name.name')"
                                         :type="errors.company_name ? 'is-danger' : null"
                                         :message="errors.company_name ? errors.company_name[0] : null">
                                    <b-input required
                                             v-model="company.company_name"
                                             icon="domain"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('companies.fields.city.name')"
                                         :type="errors.city ? 'is-danger' : null"
                                         :message="errors.city ? errors.city[0] : null">
                                    <b-input required
                                             v-model="company.city"
                                             icon="city"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('companies.fields.address.name')"
                                         :type="errors.address ? 'is-danger' : null"
                                         :message="errors.address ? errors.address[0] : null">
                                    <b-input required
                                             v-model="company.address"
                                             icon="map-marker"
                                    ></b-input>
                                </b-field>

                                <b-field class="checkbox-wrapper mb-3">
                                    <b-checkbox v-model="termsAccepted"
                                                required
                                                input-id="terms"
                                                true-value="1"
                                                false-value="0">
                                    </b-checkbox>
                                    <label class="label" for="terms">
                                        <i18n-t keypath="auth.sign_up.terms_and_conditions_consent" tag="span">

                                            <template #link>
                                                <a href="/regulamin" target="_blank">
                                                    {{ $t('auth.sign_up.terms_and_conditions_label') }}
                                                </a>
                                            </template>

                                        </i18n-t>
                                    </label>
                                </b-field>

                                <b-field class="checkbox-wrapper mb-3">
                                    <b-checkbox v-model="privacyAccepted"
                                                required
                                                input-id="privacy"
                                                true-value="1"
                                                false-value="0">
                                    </b-checkbox>
                                    <label class="label" for="privacy">
                                        <i18n-t keypath="auth.sign_up.privacy_policy_consent" tag="span">

                                            <template #link>
                                                <a href="/polityka-prywatnosci" target="_blank">
                                                    {{ $t('auth.sign_up.privacy_policy_label') }}
                                                </a>
                                            </template>

                                        </i18n-t>
                                    </label>
                                </b-field>

                                <div class="field">
                                    <button class="button is-success is-fullwidth" type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('actions.send') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
